<template>
  <div class="c-models">
    <panel-header title="Выбор модели" />
    <div class="c-models__container" v-loading="loading">
      <div class="c-models__filter">
        <el-input
          prefix-icon="el-icon-search"
          class="r-input"
          v-model="filter"
          placeholder="Поиск по названию модели"
        />
      </div>
      <template>
        <r-simple-list
          v-if="filteredModels.length"
          style="margin: 8px"
          :list="filteredModels"
          @click-handler="clickHandler"
        />
        <div v-else class="c-models__nodata">
          <r-text type="caption">
            Нет ни одной модели. Добавьте их через менджер ИД или обратитесь к
            своему руководителю
          </r-text>
        </div>
      </template>
    </div>

    <c-help
      title="Выберите модель"
      text="В левой панели список моделей, для которых вы можете провести расчёт. Кликните по модели в списке, чтобы открыть предпросмотр на карте."
    />
  </div>
</template>

<script>
import PanelHeader from "@/components/calculations/panel-header/panel-header";
import CHelp from "@/components/calculations/help/help";
import { getDatasourcesByDatatype, getModelChildrenIds } from "@/utils";

export default {
  components: {
    PanelHeader,
    CHelp
  },
  data() {
    return {
      models: [],
      filter: "",
      loading: false
    };
  },
  computed: {
    filteredModels() {
      return this.models.filter(
        m => m.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
      );
    }
  },
  methods: {
    clickHandler({ id, children, name }) {
      const ids = getModelChildrenIds(children);
      const value = {
        id,
        ids,
        name,
        children
      };
      this.$store.commit("SET_CALC_FIELD", { field: "model", value });
      this.$router.push(`/app/calculations/${id}`);
    }
  },
  async created() {
    try {
      this.loading = true;
      const where = {
        field: "datatype",
        op: "=",
        value: "model",
        type: "AND"
      };
      const include = { children: {} };
      const models = await getDatasourcesByDatatype(this, where, include);

      this.models = models.map(m => ({
        ...m,
        title: m.name,
        subtitle: m.branch_count
          ? `Сценариев: ${m.branch_count}`
          : "Сценарии отсутствуют",
        icon: "model"
      }));
      this.loading = false;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.c-models {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 48px);
  width: 260px;
  position: relative;

  &__container {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 0px;
  }

  &__filter {
    padding: 8px;
  }

  &__nodata {
    padding: 40px 8px;
    text-align: center;
  }
}
</style>
